import React from "react";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography
} from '@material-ui/core';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';


// keyData = w/kg, wTSS 등의 기준으로 필터된 데이터
export default function RankTable({ keyData, keyword }) {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.container}>
        <TableContainer component={Paper}>
          <Table
            aria-label="simple table"
            size="large"
            className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableRow}>
                <TableCell>
                  <Box className={classes.tableTitle}>순위</Box>
                </TableCell>
                <TableCell>
                  <Box className={classes.tableTitle}>닉네임</Box>
                </TableCell>
                <TableCell>
                  <Box className={classes.tableTitle}>{keyword}</Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {keyData &&
                keyData?.length > 0 &&
                keyData.slice(0, 3).map((rank, idx) => (
                  <TableRow key={idx} className={classes.tableContent}>
                    <Box className={classes.rank}>
                      <EmojiEventsOutlinedIcon
                        className={
                          idx === 0
                            ? `${classes.trophyIcon} yellow`
                            : idx === 1
                              ? `${classes.trophyIcon} silver`
                              : `${classes.trophyIcon} bronze`
                        }
                      />
                      <TableCell className={classes.tableCell}>{idx + 1}</TableCell>
                    </Box>
                    <TableCell className={classes.tableCell}>{rank.displayName}</TableCell>
                    <TableCell className={classes.tableCell}>{(keyword==='w/kg') ? `${rank.wkg}.xx` : `${rank.lastWeekTss}`}</TableCell>
                  </TableRow>
                ))}
              {keyData &&
                keyData?.length > 3 &&
                keyData.slice(3).map((rank, idx) => (
                  <TableRow key={idx + 3} className={classes.tableContent}>
                    {' '}
                    {/* 3을 더해 고유한 key를 생성 */}
                    <Box className={classes.rank}>
                      <EmojiEventsOutlinedIcon
                        style={{ color: 'transparent' }}
                      />
                      <TableCell className={classes.tableCell}>{idx + 4}</TableCell>{' '}
                      {/* 실제 순위를 표시하기 위해 4를 더함 */}
                    </Box>
                    <TableCell className={classes.tableCell}>{rank.displayName}</TableCell>
                    <TableCell className={classes.tableCell}>{(keyword==='w/kg') ? `${rank.wkg}.xx` : `${rank.lastWeekTss}`}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    //    padding: theme.spacing(2)
  },
  container: {
    marginBottom: '16px'
  },
  table: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    },
    position: 'relative' // 상대적 위치 지정
  },
  tableRow: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 8px'
  },
  tableCell: {
    fontSize:'12px',
    border:'none',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px'
    }
  },
  tableTitle: {
    minWidth: '52px',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  tableContent: {
    flexGrow: 1,
    borderBottom: '1px #eeeeee solid',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 8px',
    '&:last-child': {
      borderBottom: '0px'
    },
  },
  rank: {
    display: 'flex',
    alignItems: 'center'
  },
  trophyIcon: {
    '&.yellow': {
      color: '#FFD400'
    },
    '&.silver': {
      color: 'silver' // 1번 트로피의 색상
    },
    '&.bronze': {
      color: '#624637'
    }
  }
}));